import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className="sidebar">
        <h4 className="text-center py-3"><a className="navbar-brand" href="https://st.tjdstore.in"><img className="logoimg" alt="Logo" width={186} src="https://st.tjdstore.in/images/logo-white.png" /></a></h4>
        <ul>

                  <li className="nav-item">
                    <Link className="nav-link" to="/ProductForm">Stock for Store </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/Alldata">All Product </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/Addproduct">ADD Product </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/BarcodePrinter">Barcode Print</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/Protanya">Stock for Tanya</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/RefundForm">Refund Request</Link>
                  </li>                    
                  <li className="nav-item">
                    <Link className="nav-link" to="/RefundList">Refund List</Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link className="nav-link" to="/LabelPrinter">LabelPrinter</Link>
                  </li>                  
                  <li className="nav-item">
                    <Link className="nav-link" to="/Tjdproperty">Tjd-Property Tag</Link>
                  </li>                                     */}
                </ul>
      </div>
    );
};

export default Header;
